/**
 * React Query `retry` that gives up at once on a definitive client error
 * (403/404/422...): retrying a 403 just repeats the same refusal. Network
 * errors, 5xx, 401 (a token refresh may fix it), 408 and 429 are retried up
 * to three times.
 */
export function retryUnlessClientError(failureCount: number, error: unknown): boolean {
  const status =
    error && typeof error === "object" && "status" in error && typeof error.status === "number"
      ? error.status
      : 0;
  if (status >= 400 && status < 500 && ![401, 408, 429].includes(status)) return false;
  return failureCount < 3;
}
